export default __webpack_public_path__ + "static/media/preview_sprinter.d6c29bf7.webp";